// extracted by mini-css-extract-plugin
module.exports = {"btn-zalo":"btn-zalo"};